import { validateApiResponseWithZod } from '@nw/shared/utils';

import { DefaultProductTypes } from '../../../types/ProductTypes';
import { DefaultProductSchema } from '../../../types/Schemas.zod';

import { DefaultProductConfigDTO } from '../../dtos/product.dtos';

import { getProductSegmentConfigTransformer } from '../productSegmentConfigTransformer';

export const getFormConfigTransformer = (
  data: DefaultProductTypes
): DefaultProductConfigDTO => {
  const validateResponse = validateApiResponseWithZod(
    data,
    DefaultProductSchema
  ) as DefaultProductTypes;

  const {
    product_code,
    extra_data,
    is_active,
    product_config,
    product_details: {
      pricing_type,
      product_price,
      installment_pricing_details,
      applicable_discounts: product_applicable_discounts
    },
    program,
    program_config,
    program_extra_info,
    program_image_url,
    program_info,
    program_subscription_url,
    tnc_to_accept,
    currency,
    dependent_product_code,
    dependent_product_code_condition,
    allowed_no_of_purchases,
    error_messages_config,
    registration_messages_config,
    user_extra_info_config,
    product_info
  } = validateResponse;

  const productSegmentConfig = getProductSegmentConfigTransformer(
    JSON.parse(product_config)
  );

  const productConfig: DefaultProductConfigDTO = {
    productCode: product_code,
    extraData: JSON.parse(extra_data),
    isActive: is_active,
    productSegmentConfig: productSegmentConfig,
    program: program,
    programConfig: program_config,
    programExtraInfo: program_extra_info,
    programImageUrl: program_image_url,
    programInfo: program_info,
    programSubscriptionUrl: program_subscription_url,
    productDetails: {
      pricingType: pricing_type,
      productPrice: product_price,
      installmentPricingDetails: installment_pricing_details,
      applicableDiscounts: product_applicable_discounts
    },
    tncToAccept: tnc_to_accept,
    currency: currency,
    dependentProductCode: dependent_product_code,
    dependentProductCodeCondition: dependent_product_code_condition,
    allowedNoOfPurchases: allowed_no_of_purchases,
    errorMessagesConfig: JSON.parse(error_messages_config),
    registrationMessagesConfig: JSON.parse(registration_messages_config),
    formFieldStepConfig: JSON.parse(user_extra_info_config),
    productInfo: product_info ? JSON.parse(product_info) : null
  };
  return productConfig;
};
